
import React from "react";
import { Accordion, AccordionPanel, Panel, ScrollPanel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { DialogPage } from "../overlay/DialogPage";
import { Scheme } from "@ronuse/norseu/core/variables";

export class ScrollPanelPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <ScrollPanel style={{flex: 1, width:"400px", height:"300px"}} hideScrollBars>
                                <h3>Hidden Scrollbars</h3>
                                {DialogPage.overflowText()}
                            </ScrollPanel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <ScrollPanel style={{flex: 1, width:"400px", height:"300px"}} isForm onSubmit={(e) => console.log("Yeah")}>
                                <h3>Auto Scrollbars</h3>
                                <div style={{width: "500px"}}>
                                    {DialogPage.overflowText()}
                                </div>
                                <Button text="Submit"/>
                            </ScrollPanel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <ScrollPanel style={{flex: 1, width:"400px", height:"300px"}} hideScrollBarX>
                                <h3>Hidden X-Axis Scrollbar</h3>
                                <div style={{width: "500px"}}>
                                    {DialogPage.overflowText()}
                                </div>
                            </ScrollPanel>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <ScrollPanel scheme={Scheme.PRIMARY} style={{flex: 1, width:"400px", height:"300px"}}>
                                <h3>Primary Scheme</h3>
                                {DialogPage.overflowText()}
                            </ScrollPanel>
                            <br/><br/>
                            <ScrollPanel scheme={Scheme.WARNING} style={{flex: 1, width:"400px", height:"300px"}}>
                                <h3>Warning Scheme</h3>
                                {DialogPage.overflowText()}
                            </ScrollPanel>
                            <br/><br/>
                            <ScrollPanel scheme={Scheme.DANGER} style={{flex: 1, width:"400px", height:"300px"}}>
                                <h3>Danger Scheme</h3>
                                {DialogPage.overflowText()}
                            </ScrollPanel>
                            <br/><br/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "ScrollPanel",
            import_statement: "import { ScrollPanel } from '@ronuse/norseu/core/panels'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/panels/ScrollPanelPage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "text", type: "string", default: "", description: "The label to show in the button" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
    ]

}
